/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.
*/

(function() {

  // =========================
  // Uniform product galleries
  // =========================

  (function () {

    const DESKTOP_BREAKPOINT = 750;
    const UNIFORM_RATIO = 0.8; // width / height

    function setUniformHeight(gallery) {

      if (!gallery) return;

      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        gallery.style.removeProperty('--height');
        return;
      }

      const wrapper = gallery.closest('.product__wrapper--uniform');
      if (!wrapper) return;

      const slides = gallery.querySelector('.product__slides');
      if (!slides) return;

      const width = slides.clientWidth || gallery.clientWidth;
      if (!width) return;

      const height = Math.round(width / UNIFORM_RATIO);

      gallery.style.setProperty('--height', height + 'px');
    }

    function bindUniformGallery(gallery) {

      if (!gallery || gallery.dataset.uniformBound === 'true') return;

      gallery.dataset.uniformBound = 'true';

      const run = () => {

        requestAnimationFrame(() => {

          requestAnimationFrame(() => {
            setUniformHeight(gallery);
          });

        });

      };

      run();

      gallery.addEventListener('theme:media:select', run);

      window.addEventListener('resize', run);

      const thumbs = gallery
        .closest('[data-product]')
        ?.querySelectorAll('[data-thumb-link]');

      thumbs?.forEach((thumb) => {
        thumb.addEventListener('click', run);
      });

      gallery.querySelectorAll('img').forEach((img) => {

        if (!img.complete) {
          img.addEventListener('load', run, { once: true });
        }

      });

    }

    function initUniformGalleries(root = document) {

      root
        .querySelectorAll('.product__wrapper--uniform product-images')
        .forEach(bindUniformGallery);

    }

    document.addEventListener('DOMContentLoaded', () => {
      initUniformGalleries();
    });

    document.addEventListener('shopify:section:load', (e) => {
      initUniformGalleries(e.target);
    });

  })();


  // ==========================================
  // Move vendor above product title
  // Product page only
  // Works for products with "Lalaby -"
  // ==========================================

  (function () {

    function moveVendorAboveTitle(root = document) {

      if (!document.body.classList.contains("template-product")) return;

      const titles = root.querySelectorAll(".product__title");

      titles.forEach((titleWrapper) => {

        if (titleWrapper.parentNode.querySelector(".product__vendor-custom")) {
          return;
        }

        const titleElement =
          titleWrapper.querySelector("span") || titleWrapper;

        if (!titleElement) return;

        const originalTitle = titleElement.textContent.trim();

        if (!/^Lalaby\s*[-–—]\s*/i.test(originalTitle)) return;

        const cleanedTitle = originalTitle
          .replace(/^Lalaby\s*[-–—]\s*/i, "")
          .trim();

        titleElement.textContent = cleanedTitle;

        const brand = document.createElement("div");

        brand.className = "product__vendor-custom";
        brand.textContent = "Lalaby";

        titleWrapper.parentNode.insertBefore(brand, titleWrapper);

      });

    }

    document.addEventListener("DOMContentLoaded", () => {
      moveVendorAboveTitle();
    });

    window.addEventListener("load", () => {
      moveVendorAboveTitle();
    });

    document.addEventListener("shopify:section:load", (e) => {
      moveVendorAboveTitle(e.target);
    });

    setTimeout(moveVendorAboveTitle, 100);
    setTimeout(moveVendorAboveTitle, 300);
    setTimeout(moveVendorAboveTitle, 600);
    setTimeout(moveVendorAboveTitle, 1000);

  })();


  // ==========================================
  // Remove "Lalaby -" outside product page
  // Cart, product cards, search, recommendations
  // ==========================================

  (function () {

    function removeLalabyPrefix(text) {

      return text
        .replace(/^Lalaby\s*[-–—]\s*/i, "")
        .trim();

    }

    function cleanLalabyTitles(root = document) {

      const titleSelectors = [

        // Cart
        '.cart__item__title',
        '.cart-item__title',
        '.cart__item-title',
        '[data-cart-item-title]',

        // Product cards
        '.product-item__title',
        '.product-card__title',
        '.grid-product__title',
        '.product-grid-item__title',

        // Search
        '.predictive-search__item-heading',
        '.predictive-search__item-title',
        '.search-results__title',
        '.search-result__title',
        '.search__result-title',
        '.search__product-title',

        // Recommendations
        '.recommendations__title'

      ].join(',');

      const titleElements = root.querySelectorAll(titleSelectors);

      titleElements.forEach((titleElement) => {

        if (!titleElement) return;

        // Skip main product title
        if (
          document.body.classList.contains("template-product") &&
          titleElement.closest(".product__title")
        ) {
          return;
        }

        const originalTitle = titleElement.textContent.trim();

        if (!/^Lalaby\s*[-–—]/i.test(originalTitle)) return;

        titleElement.textContent = removeLalabyPrefix(originalTitle);

      });

    }

    function runCleanLalabyTitles(root = document) {

      cleanLalabyTitles(root);

      requestAnimationFrame(() => {
        cleanLalabyTitles(root);
      });

      setTimeout(() => cleanLalabyTitles(root), 100);
      setTimeout(() => cleanLalabyTitles(root), 300);
      setTimeout(() => cleanLalabyTitles(root), 600);
      setTimeout(() => cleanLalabyTitles(root), 1000);

    }

    document.addEventListener("DOMContentLoaded", () => {
      runCleanLalabyTitles();
    });

    window.addEventListener("load", () => {
      runCleanLalabyTitles();
    });

    document.addEventListener("shopify:section:load", (e) => {
      runCleanLalabyTitles(e.target);
    });

    document.addEventListener("theme:cart:change", () => {
      runCleanLalabyTitles();
    });

    document.addEventListener("cart:refresh", () => {
      runCleanLalabyTitles();
    });

    document.addEventListener("input", () => {
      runCleanLalabyTitles();
    });

    const observer = new MutationObserver(() => {
      cleanLalabyTitles();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  })();


  // =========================
  // Collection filter nav fix
  // =========================

  (function () {

    function getVisibleHeaderBottom() {

      const headers = document.querySelectorAll(
        '.header__desktop, .header__mobile, header-component, [data-header-height], .header'
      );

      let bottom = 0;

      headers.forEach(function(header) {

        const style = window.getComputedStyle(header);
        const rect = header.getBoundingClientRect();

        if (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          rect.height > 0 &&
          rect.bottom > bottom
        ) {
          bottom = rect.bottom;
        }

      });

      return bottom || 72;

    }


    function fixCollectionNavPosition() {

      if (
        !document.body.classList.contains('template-collection') &&
        !document.body.classList.contains('template-search')
      ) return;

      const nav = document.querySelector('.collection__nav');

      if (!nav) return;

      const headerBottom = getVisibleHeaderBottom();

      nav.style.setProperty('position', 'sticky', 'important');
      nav.style.setProperty('top', headerBottom + 'px', 'important');
      nav.style.setProperty('margin-top', '0px', 'important');
      nav.style.setProperty('transform', 'none', 'important');

    }


    function runFix() {

      fixCollectionNavPosition();

      requestAnimationFrame(() => {
        fixCollectionNavPosition();
      });

      setTimeout(fixCollectionNavPosition, 100);
      setTimeout(fixCollectionNavPosition, 300);
      setTimeout(fixCollectionNavPosition, 600);
      setTimeout(fixCollectionNavPosition, 1000);

    }


    document.addEventListener('DOMContentLoaded', runFix);

    window.addEventListener('load', runFix);

    window.addEventListener('resize', runFix);

    window.addEventListener(
      'scroll',
      fixCollectionNavPosition,
      { passive: true }
    );

    document.addEventListener('theme:resize', runFix);

    document.addEventListener('shopify:section:load', runFix);

  })();

})();